import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../../assets/image/all/login_header.png';
const _hoisted_1 = {
  class: "login-wrapper"
};
const _hoisted_2 = {
  class: "login-box"
};
const _hoisted_3 = {
  class: "login-tabs-container"
};
const _hoisted_4 = {
  class: "input-wrapper"
};
const _hoisted_5 = {
  class: "phone-input login-input-wrapper"
};
const _hoisted_6 = {
  class: "input-body"
};
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = {
  class: "login-input-wrapper"
};
const _hoisted_9 = {
  class: "input-body"
};
const _hoisted_10 = ["placeholder"];
const _hoisted_11 = {
  class: "input-wrapper"
};
const _hoisted_12 = {
  class: "account-input login-input-wrapper"
};
const _hoisted_13 = {
  class: "input-body"
};
const _hoisted_14 = ["placeholder"];
const _hoisted_15 = {
  class: "password-input login-input-wrapper"
};
const _hoisted_16 = {
  class: "input-body"
};
const _hoisted_17 = ["type", "placeholder"];
const _hoisted_18 = {
  key: 0,
  class: "login-footer"
};
const _hoisted_19 = {
  class: "checkbox-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[18] || (_cache[18] = _createElementVNode("div", {
    class: "login-header"
  }, [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_tabs, {
    active: $setup.loginActive,
    "onUpdate:active": _cache[9] || (_cache[9] = $event => $setup.loginActive = $event),
    "line-width": "20",
    animated: "",
    color: "#4E82FF",
    "title-active-color": "#323233",
    "title-inactive-color": "#969799"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: _ctx.$t('短信登录')
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "input-icon"
      }, [_createElementVNode("div", {
        class: "phone"
      })], -1)), _withDirectives(_createElementVNode("input", {
        type: "tel",
        placeholder: _ctx.$t('请输入手机号'),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.phoneInput = $event),
        onFocusout: _cache[1] || (_cache[1] = (...args) => _ctx.inputFocusOut && _ctx.inputFocusOut(...args))
      }, null, 40, _hoisted_7), [[_vModelText, $setup.phoneInput]])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
        type: "tel",
        placeholder: _ctx.$t('请输入验证码'),
        maxlength: "6",
        class: "sec-input",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.codeInput = $event)
      }, null, 8, _hoisted_10), [[_vModelText, $setup.codeInput]]), _cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "input-icon"
      }, [_createElementVNode("div", {
        class: "sms"
      })], -1)), _createElementVNode("div", {
        class: "msg-btn",
        onClick: _cache[3] || (_cache[3] = $event => $setup.sendMsg())
      }, _toDisplayString($setup.send), 1)])])])]),
      _: 1
    }, 8, ["title"]), _createVNode(_component_van_tab, {
      title: _ctx.$t('密码登录')
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "input-icon"
      }, [_createElementVNode("div", {
        class: "account"
      })], -1)), _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: _ctx.$t('请输入账号'),
        required: "",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.inputUserId = $event),
        onFocusout: _cache[5] || (_cache[5] = (...args) => _ctx.inputFocusOut && _ctx.inputFocusOut(...args))
      }, null, 40, _hoisted_14), [[_vModelText, $setup.inputUserId]])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[17] || (_cache[17] = _createElementVNode("div", {
        class: "input-icon"
      }, [_createElementVNode("div", {
        class: "password"
      })], -1)), _withDirectives(_createElementVNode("input", {
        type: $setup.pwType,
        placeholder: _ctx.$t('请输入密码'),
        name: "password",
        class: "sec-input",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.userPw = $event),
        onKeydown: _cache[7] || (_cache[7] = (...args) => $setup.handleKeydownSms && $setup.handleKeydownSms(...args)),
        required: ""
      }, null, 40, _hoisted_17), [[_vModelDynamic, $setup.userPw]]), _createElementVNode("div", {
        onClick: _cache[8] || (_cache[8] = (...args) => $setup.changePwType && $setup.changePwType(...args)),
        class: _normalizeClass(`${$setup.pwType === 'password' ? 'pw-hide-icon' : 'pw-show-icon'} pw-right-icon bg-other`)
      }, null, 2)])])])]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["active"]), _createElementVNode("div", {
    class: "login-btn",
    onClick: _cache[10] || (_cache[10] = $event => $setup.LoginBtn())
  }, _toDisplayString(_ctx.$t('立即登录')), 1)])]), $setup.showFooter ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_van_checkbox, {
    modelValue: $setup.checked,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $setup.checked = $event),
    "checked-color": "#5e8eff",
    "icon-size": "16"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createTextVNode(_toDisplayString(_ctx.$t('我已阅读并同意')) + " ", 1), _createElementVNode("span", {
      onClick: _cache[11] || (_cache[11] = _withModifiers($event => $setup.goYsxy(), ["stop"])),
      class: "ruler-title"
    }, _toDisplayString(_ctx.$t('《用户协议》')), 1), _cache[19] || (_cache[19] = _createTextVNode("及")), _createElementVNode("span", {
      class: "ruler-title",
      onClick: _cache[12] || (_cache[12] = _withModifiers($event => $setup.goYhxy(), ["stop"]))
    }, _toDisplayString(_ctx.$t('《隐私条款》')), 1)])]),
    _: 1
  }, 8, ["modelValue"])])) : _createCommentVNode("", true)]);
}